import { CancelAkaHouseContentsFormValues } from '../cancelAkaHouseContentsForm.types';

export function mapInitialValuesAkaHouseContentsCancellation(): CancelAkaHouseContentsFormValues {
  return {
    cancelReason: undefined,
    futureCancelDate: undefined,
  };
}
